export const TEST_ID = 'kpiStrip';

export const NEXT_SERVICE_VALUE = '4d';

export const NEXT_SERVICE_SUB = 'Drone 03 · pump seal replacement';

export const PERCENT_MULTIPLIER = 100;
